import React from 'react'
import PropTypes from 'prop-types'
import dateSet from 'date-fns/setDay'
import dateFormat from 'date-fns/format'

const ChoresCard = ({ chore, callback }) => {
  const {
    name,
    repeat: { interval },
    price,
  } = chore

  const formattedRepeat = interval && dateFormat(dateSet(new Date(), interval), 'EEEE')

  return (
    <div
      className="flex flex-wrap w-full h-full px-6 py-4 duration-500 bg-white rounded-lg shadow-sm cursor-pointer hover:shadow-lg transition:all"
      onClick={() => callback(chore)}
    >
      <div className="w-full text-xl text-pink-400">{name}</div>
      <div className="w-full text-gray-400">
        {formattedRepeat ? <div>Every {formattedRepeat}</div> : <div>Today</div>}
      </div>
      <div className="w-full">
        <span className="font-bold">{price}</span>
        <span> points</span>
      </div>
    </div>
  )
}

ChoresCard.propTypes = {
  chore: PropTypes.object.isRequired,
  options: PropTypes.array.isRequired,
  callback: PropTypes.func.isRequired,
}

export default ChoresCard
